"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateBlock = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _BlockType = require("../BlockType");
var _variables = require("@blockwell/variables");
const settings = [{
  title: "Template",
  settings: _variables.TemplateVariable.settings
}];
class TemplateBlock extends _BlockType.BlockType {
  constructor(param, variableTypes) {
    super();
    (0, _defineProperty2.default)(this, "type", "template");
    (0, _defineProperty2.default)(this, "noChildren", true);
    (0, _defineProperty2.default)(this, "templateVariable", void 0);
    this.param = param;
    this.templateVariable = this.addBlockVariable(variableTypes.get("template"), param, ["template"]);
  }
  renderValue() {
    let render = this.templateVariable.value();
    return {
      value: _variables.vals.stringValue(render)
    };
  }
}
exports.TemplateBlock = TemplateBlock;
(0, _defineProperty2.default)(TemplateBlock, "settings", settings);
(0, _defineProperty2.default)(TemplateBlock, "primarySetting", "template");
//# sourceMappingURL=TemplateBlock.js.map